import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-bachelor-of-business-administration-program',
  templateUrl: './bachelor-of-business-administration-program.component.html',
  styleUrls: ['./bachelor-of-business-administration-program.component.scss']
})
export class BachelorOfBusinessAdministrationProgramComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
